module.exports = __webpack_public_path__ + "3873bf6687c51a3144795638688e0ee3.svg";